/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { checkApiKeyManagementKeysResource } from '@jira/router-resources__eoc-api-key-management/src/checkApiKeyManagementKeysResource.tsx';
import { useResource } from '@atlassian/react-resource-router';

export const useApiKeyManagementInfo = (): {
	hasKeys: boolean;
	loading: boolean;
	error: // oxlint-disable-next-line @typescript-eslint/no-explicit-any
		| Record<string, any>
		| Error // oxlint-disable-next-line @typescript-eslint/no-explicit-any
		| (Record<string, any> & Error) // oxlint-disable-next-line @typescript-eslint/no-explicit-any
		| (Error & Record<string, any>)
		| null;
} => {
	const { loading, error, data } = useResource(checkApiKeyManagementKeysResource());
	return {
		hasKeys: data ?? false,
		loading,
		error,
	};
};
